module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_4.679dd1bb.png";